<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city'> 
          <head_menu :has-back=true @go-back-click="goBack" :has-next=true @go-next-click="goNext">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{"Cross City"}}
              </div>
            </template>
          </head_menu>

          <el-row>
            <el-col :span="24">
              <el-table tooltip-effect="light"
                :data="selectedMultProposal"  sum-text="$t('message.summary')"
                show-summary :summary-method="getSummaries"
               
                style="width: calc(100% - 30px); margin: 5px 15px;">
                <el-table-column prop="city" :label="$t('message.City')">
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('message.Client_name')" prop="clientName">
                </el-table-column>
                <el-table-column prop="bus_line_qty" :label="$t('message.Bus_Line_Qty')">
                </el-table-column>
                <el-table-column prop="bus_body_qty" :label="$t('message.Bus_Body_Qty')">
                </el-table-column>
                <el-table-column prop="viewed_impression" :label="$t('message.Viewed_Impression')" :formatter="stateFormat">
                </el-table-column>
                <el-table-column prop="viewed_impression_cluster" :label="$t('message.Viewed_Impression(Audience)')" :formatter="stateFormat">
                </el-table-column>
                <el-table-column prop="CPM" :label="$t('message.CPM')">
                </el-table-column>
                <el-table-column prop="CPM_cluster" :label="$t('message.CPM_Target_Audience_Based')">
                </el-table-column>
                <el-table-column prop="estimated_cost" :label="$t('message.Gross_Price')" :formatter="stateFormat">
                </el-table-column>
              </el-table>
              <!-- <el-table
                :data="summaryTable" show-summary :summary-method="getSummaries" sum-text="$t('message.summary')"
                :row-class-name="summaryTableRowClassName"
                style="width: calc(100% - 30px); margin: 5px 15px;">
                <el-table-column prop="name" :label="$t('message.City')">
                </el-table-column>
                <el-table-column prop="line_qty" :label="$t('message.Bus_Line_Qty')">
                </el-table-column>
                
                <el-table-column prop="body_qty" :label="$t('message.Bus_Body_Qty')">
                </el-table-column>
                <el-table-column prop="impression" :label="$t('message.Viewed_Impression')" :formatter="stateFormat">
                </el-table-column>
                <el-table-column prop="impression_cluster" :label="$t('message.Viewed_Impression(Audience)')" :formatter="stateFormat">
                </el-table-column>
                <el-table-column prop="cpm" :label="$t('message.CPM')">
                </el-table-column>
                <el-table-column prop="cpm_cluster" :label="$t('message.CPM_Target_Audience_Based')">
                </el-table-column>
                <el-table-column prop="price" :label="$t('message.Gross_Price')" :formatter="stateFormat">
                </el-table-column>
              </el-table> -->
            </el-col>
          </el-row>

          <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="4">
              <div class="div_navi">
                <p class="p_navi_button" v-on:click="backToCity">
                  {{$t('message.Back')}}
                </p>
              </div>
            </el-col>
          
          
            <el-col :span="8">
              <div>
          
              </div>
            </el-col>
          
            <el-col :span="4">
              <div style="background-color: #909399;">
                <p :class="!enableNext? 'p_navi_button_disabled':'p_navi_button'" v-on:click="goNext">
                  {{$t('message.Next')}}
                </p>
              </div>
            </el-col>
          </el-row>

          <el-row style="margin-top: 30px" v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-col :span="24">
              <el-tabs id="choose_city_tab" v-model="activeCity" type="card" @tab-click="changeCityTab" stretch> 
                <el-tab-pane v-if="hasNanjing" :label="$t('message.Nanjing')" name="Nanjing"></el-tab-pane>
                <el-tab-pane v-if="hasWuhan" :label="$t('message.Wuhan')" name="Wuhan"></el-tab-pane>
                <el-tab-pane v-if="hasShenzhen" :label="$t('message.Shenzhen')" name="Shenzhen"></el-tab-pane>
                <el-tab-pane v-if="hasChongqing" :label="$t('message.Chongqing')" name="Chongqing"></el-tab-pane>
                <el-tab-pane v-if="hasChengdu" :label = "$t('message.Chengdu')" name="Chengdu"></el-tab-pane>
              </el-tabs>

              <div>
                <el-alert v-if="selectedProposals[activeCity]==''"
                  type="warning" center :closable="false" show-icon
                  :title="$t('message.Please_select_a_proposal')" >
                </el-alert>
                
                <el-alert v-else
                  type="success" center :closable="false" show-icon
                  :title="$t('message.Proposal_selected') + selectedProposal" >
                </el-alert>
              </div>

              <el-table tooltip-effect="light" :data="proposalList" style="width: calc(100% - 40px); margin: 15px 20px">
                <el-table-column label="" width="35">
                  <template slot-scope="props">
                    <el-checkbox v-model='props.row.checked'  @change="handleRadioChange_test(props.row.id, props.row)"></el-checkbox>
                    <!-- <el-radio v-model="radio" :label="props.row.id" @change="handleRadioChange(props.row.id, props.row)">{{''}}</el-radio> -->
                  </template>
                </el-table-column>
                <el-table-column type="expand" width="35">
                  <template slot-scope="props">
                    <div style="backgroud: grey">
                      <el-row style="margin-left: -10px; margin-right: -10px;" type="flex">
                        <el-col :span="8" class="info-list-style" style="min-height:280px;padding-left:30px;" >

                          <div style="text-align: left; margin-top: 10px" id ='selected_criterias'>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Gender')}}:</p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_audience.value_gender}}</p>
                              </el-col>
                            </el-row>

                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Age')}}: </p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_audience.value_age}}</p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Spend_Power')}}: </p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_audience.value_spend_power}}</p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Interests')}}: </p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_audience.value_interest}}</p>
                              </el-col>

                            </el-row>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.POI')}}: </p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_poi}}</p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Media_Format')}}: </p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_media}}</p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin:10px" v-if="props.row.ifShowViewed">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Rank')}}:</p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.data_rank}}</p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="margin:10px">
                              <el-col :span="7">
                                <p class="p9">{{$t('message.Nearby_Location')}}:</p>
                              </el-col>
                              <el-col :span="17">
                                <p class="p10">{{props.row.poi_ba_label_selection_list}}</p>
                              </el-col>
                            </el-row>
                          </div>

                        </el-col>
                        
                        
                        <el-col :span="8" class="info-list-style" style="min-height:280px;border-left:5px solid #EFEFEF;
                                      border-right:5px solid #EFEFEF" >
                              <div style="background-color: white;margin:10px;height:40px;text-align:center">
                                <div style="padding: 5px;font-size: 18px;color:#254A6E;font-weight: 600;">
                                  <!-- <span>{{$t('message.Campaign_Starting_Date')}}(typeof(props.row.date) =='number')?({{new Date(props.row.date*1000).toISOString().split('T')[0]}}):({{props.row.date}}) </span> -->
                                  <!--<span>{{$t('message.Campaign_Starting_Date')}} {{props.row.date}}</span>-->
                                </div>
                              </div>

                        <div id='KPI1'>
                          <el-row :gutter="20">
                            <el-col :span="8">
                              <p class="p7">{{$t('message.Number_of_Bus_Lines')}}</p>
                            </el-col>
                            <el-col :span="8">
                              <p class="p7">{{$t('message.Number_of_Bus_Body')}}</p>
                            </el-col>
                            <el-col :span="8">
                              <p class="p7">{{$t('message.Duration(Months)')}}</p>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="8">
                              <div class="div_number">
                                <p class="p8">{{props.row.bus_line_qty}}</p>
                              </div>
                            </el-col>
                            <el-col :span="8">
                              <div>
                                <p class="p8">{{props.row.bus_body_qty}}</p>
                              </div>
                            </el-col>
                            <el-col :span="8">
                              <div>
                                <p class="p8">{{props.row.duration}}</p>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20" style="margin-top: 15px">
                            <el-col :span="props.row.ifShowViewed?12:24">
                              <p class="p7" >{{$t('message.Viewed_Impression')}}
                              </p>
                            </el-col>
                            <el-col :span="props.row.ifShowViewed?12:0" v-if="props.row.ifShowViewed">
                              <p class="p7">{{$t('message.Viewed_Impression(Audience)')}}</p>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="props.row.ifShowViewed?12:24">
                              <div class="div_number">
                                <p class="p8" style="font-size: 24px;">{{props.row.viewed_impression.toLocaleString()}}</p>
                              </div>
                            </el-col>
                            <el-col :span="props.row.ifShowViewed?12:0">
                              <div>
                                <p class="p8" style="font-size: 24px;" v-if="props.row.ifShowViewed">{{props.row.viewed_impression_cluster.toLocaleString()}}</p>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                        </el-col>
                        <el-col :span="8" class="info-list-style" style="min-height:280px;padding-right:30px;">
                          <br />
                          <br />
                          <div id='KPI2'>
                         
                            <div style="height:30px;" v-if = "props.row.param_json.data_map != ''">
                              
                                <el-col :span="12" >
                                    <p class="p7">{{ $t("message.Media_Cost_RC_Discounted") }}</p>
                                    <span class="p8" style="font-size: 14px">￥{{ props.row.param_json.data_map.media_cost.toLocaleString() }} / </span> 
                                    <span class="p8" style="font-size: 18px">￥{{ props.row.param_json.data_map.media_discount_cost.toLocaleString() }}</span>
                              
                                </el-col>
                                 <el-col :span="12" >
                                    <p class="p7" style="line-height: 3;">{{ $t("message.Production_Cost_1") }}</p>
                                      <p class="p8">
                                      ￥{{ props.row.param_json.data_map.production_cost }}
                                    </p>
                                </el-col>
                              
                            </div>
                            <br />
                            <el-row v-if = "props.row.param_json.data_map != ''">
                            <el-col :span="24">
                              <div>
                                <p class="p7">{{$t('message.Proposal_Cost')}}
                                </p>
                                <p class="p8" style="font-size: 30px;">￥{{props.row.param_json.data_map.proposal_discount_cost.toLocaleString()}}</p>
                              </div>
                            </el-col>
                            </el-row>
                             <el-row v-else>
                                 <p class="p7" style="font-size:20px">{{$t('message.Total_Media_Cost')}}</p>
                                  <p class="p8" style="font-size: 30px;">￥{{props.row.estimated_cost.toLocaleString()}}</p>
                              </el-row>

                            
                            <br />
                        
                          <el-row>
                            <div v-if = "props.row.param_json.data_map != ''" >
                                <el-col :span="props.row.ifShowViewed?12:24">
                              <div>
                                <p class="p7">{{$t('message.Gross_CPM')}}
                                </p>
                                <p class="p8" style="font-size: 30px;">￥{{props.row.param_json.data_map.discount_proposal_CPM}}</p>
                              </div>
                            </el-col>
                            <el-col :span="props.row.ifShowViewed?12:0" v-if="props.row.ifShowViewed">
                              <div>
                                <p class="p7">{{$t('message.CPM_Selection_Based')}}</p>
                                
                                <p class="p8" style="font-size: 30px;">￥{{(props.row.param_json.data_map.proposal_discount_cost/props.row.param_json.viewed_impression_cluster*1000).toFixed(2)}}</p>
                              </div>
                            </el-col>
                            </div>
                            <div v-else> 
                              <el-col :span="props.row.ifShowViewed?12:24">
                              <div>
                                <p class="p7">{{$t('message.Gross_CPM')}}
                                </p>
                                <p class="p8" style="font-size: 30px;">￥{{props.row.CPM}}</p>
                              </div>
                            </el-col>
                            <el-col :span="props.row.ifShowViewed?12:0" v-if="props.row.ifShowViewed">
                              <div>
                                <p class="p7">{{$t('message.CPM_Selection_Based')}}</p>
                                <p class="p8" style="font-size: 30px;">￥{{props.row.CPM_cluster}}</p>
                              </div>
                            </el-col>
                            </div>
                           
                          </el-row>
                        </div>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('message.Created_at')" prop="createdAt" width="180">
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('message.Client_name')" prop="clientName">
                </el-table-column>
                <el-table-column :label="$t('message.City')" prop="city">
                </el-table-column>
                <el-table-column :label="$t('message.Campaign_start')" prop="campaignStart">
                </el-table-column>
                <el-table-column :label="$t('message.Campaign_end')" prop="campaignEnd">
                </el-table-column>
                <el-table-column :label="$t('message.Created_by')" prop="createdBy">
                </el-table-column>
                <el-table-column :label="$t('message.Team')" prop="team">
                </el-table-column>
                <el-table-column :label="$t('message.Status')" prop="status">
                  <template slot-scope="scope">
                    <div style="margin:10px 0; width: 100px; text-align: center;"
                            :class="{ white:(scope.row.status == $t('message.Draft')), blue: (scope.row.status == $t('message.Discussion')),
                            orange: (scope.row.status == $t('message.Sent')), pink: (scope.row.status == $t('message.Win')), black: (scope.row.status == $t('message.Fail')),
                            darkgrey: (scope.row.status == $t('message.Cancelled'))}">
                            
                            {{scope.row.status}}
                      </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import _global from "./components/global.vue";

export default {
  name: "package_selection",
  data() {
    return {
      lang: "en",
      selectedCities: [],
      summaryTableIndex: {
        "Nanjing": 0,
        "Wuhan": 1,
        "Shenzhen": 2,
        "Summary": 5,
        "Chongqing":3,
        "Chengdu":4
      },
      selectedMultProposal:[],
      summaryTable: [
        {
          name: this.$t('message.Nanjing'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          impression_cluster: 0,
          cpm: 0,
          cpm_cluster: 0,
          price: 0,
          data_audience: '',
          bus_line:[],
          date:'',
          duration:'',
          param_json:{
            ifShowViewed:0
          }
        },
        {
          name: this.$t('message.Wuhan'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          impression_cluster: 0 ,
          cpm: 0,
          cpm_cluster: 0,
          price: 0,
          data_audience: '',
          bus_line:[],
          date:'',
          duration:'',
          param_json:{
            ifShowViewed:0
          }
        },
        {
          name: this.$t('message.Shenzhen'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          impression_cluster: 0,
          cpm: 0,
          cpm_cluster: 0,
          price: 0,
          data_audience: '',
          bus_line:'',
          date:'',
          duration:'',
          param_json:{
            ifShowViewed:0
          }
        },
         {
          name: this.$t('message.Chongqing'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          impression_cluster: 0,
          cpm: 0,
          cpm_cluster: 0,
          price: 0,
          data_audience: '',
          bus_line:[],
          date:'',
          duration:'',
          param_json:{
            ifShowViewed:0
          }
        },
        {
          name: this.$t('message.Chengdu'),
          line_qty: 0,
          body_qty: 0,
          impression: 0,
          impression_cluster: 0,
          cpm: 0,
          cpm_cluster: 0,
          price: 0,
          data_audience: '',
          bus_line:[],
          date:'',
          duration:'',
          param_json:{
            ifShowViewed:0
          }
        },
      ],
      activeCity: "",
      hasNanjing: false,
      hasWuhan: false,
      hasShenzhen: false,
      hasChongqing: false,
      hasChengdu:false,
      proposalList: [],
      radio: "1",
      status_options: [{
        value: '1',
        label: this.$t('message.Draft')
      }, {
        value: '2',
        label: this.$t('message.Discussion')
      }, {
        value: '3',
        label: this.$t('message.Sent')
      }, {
        value: '4',
        label: this.$t('message.Win')
      }, {
        value: '5',
        label: this.$t('message.Fail')
      }, {
        value: '6',
        label: this.$t('message.Cancelled')
      }],
      city_options: [],
      selectedProposals : {
        "Nanjing": "",
        "NanjingValue": "",
        "Wuhan": "",
        "WuhanValue": "",
        "Shenzhen": "",
        "ShenzhenValue": "",
        "Chongqing":"",
        "ChongqingValue":"",
        "Chengdu":"",
        "ChengduValue":""
      },
      loading: true,
    }
  },
  computed:{
    localLang() {
      return this.$i18n.locale;
    },
    enableNext() {
      let bool = true
      for (let city of this.selectedCities) {
        bool = bool && this.summaryTable[this.summaryTableIndex[city]].bus_line.length > 0 && this.selectedMultProposal.length >= 2
      }

      return bool
    },
    selectedProposal() {
      let name = this.selectedProposals[this.activeCity+"Value"].clientName
      return (name && name.length>0) ? " : " + name : "";
    }
  },
  watch: {
    localLang() {
      this.summaryTable[0].label = this.$t('message.Nanjing');
      this.summaryTable[1].label = this.$t('message.Wuhan');
      this.summaryTable[2].label = this.$t('message.Shenzhen');
      this.summaryTable[3].label = this.$t('message.Chongqing');
      this.summaryTable[4].label = this.$t('message.Chengdu');
      
      this.updateStatusOption();
      for (let ele of this.proposalList) {
        ele.status = this.proposalStatusChange(ele.proposal_status)
      }

      for (let ele of this.proposalList) {
        ele.data_audience = {...ele.param_json.data_audience}
        ele.data_audience.value_gender = this.changeDataToText(ele.data_audience.value_gender, this.options.audience_options.gender_options)
        ele.data_audience.value_age = this.changeDataToText(ele.data_audience.value_age, this.options.audience_options.age_options)
        ele.data_audience.value_spend_power = this.changeDataToText(ele.data_audience.value_spend_power, this.options.audience_options.spend_power_options)
        ele.data_audience.value_interest = this.changeDataToText(ele.data_audience.value_interest, this.options.audience_options.interest_options)
        
       ele.data_poi =  this.changeDataToText_poi(ele.param_json.data_poi)
        ele.data_media = this.changeDataToText(ele.param_json.data_media, this.options.media_rank_options.media_format_options)
       
       ele.data_rank = this.changeDataToText(ele.param_json.data_rank, this.options.media_rank_options.rank_options)   
      }
    }
  },
  components: {
    head_page,
    head_menu,
  },
  created() {
    this.selectedCities = this.$route.query['cities']
    if (this.selectedCities.includes("Nanjing")) this.hasNanjing=true;
    if (this.selectedCities.includes("Wuhan")) this.hasWuhan=true;
    if (this.selectedCities.includes("Shenzhen")) this.hasShenzhen=true;
    if (this.selectedCities.includes("Chongqing")) this.hasChongqing = true;
    if (this.selectedCities.includes("Chengdu")) this.hasChengdu = true;
    this.activeCity = this.hasNanjing ? "Nanjing" : (this.hasWuhan ? "Wuhan" : (this.hasShenzhen ? "Shenzhen" :this.hasChongqing ? "Chongqing" : "Chengdu"))
  },
  mounted() {
    this.$refs.head_page.update_user_name();
    this.getHistoryData();
  },
  updated(){
  
  },
  methods: {
    getHistoryData() {
      this.loading = true;
      let api_url = _global.serverSrc + '/get_user_history_by_user_and_city/?format=json';
      let obj = {}
      obj.email = JSON.parse(sessionStorage.getItem('User'))
      obj.city = this.activeCity
      this.$axios.post(api_url, obj)
        .then(response => {
          if (response.data != null) {
            this.options = response.data.options.options

            this.proposalList = []
            for (let ele of response.data.user_history) {
              let tmp = {}
              tmp.id = ele.reference_id
              tmp.createdAt = ele.created_at
              tmp.city = ele.city
              tmp.clientName = ele.client_name
              tmp.campaignStart = ele.campaign_start
              tmp.campaignEnd = ele.campaign_end
              tmp.createdBy = ele.created_by
              tmp.impressions = Number(ele.viewed_impression)
              tmp.total_media_budget = Number(ele.estimated_cost)
              tmp.total_bus_line = Number(ele.number_bus)
              tmp.team = ele.bu_city
              tmp.status = this.proposalStatusChange(ele.proposal_status)
              //tmp.status = ele.proposal_status
              tmp.isChanged = false
              //tmp.status_options = this.createSelfOption(ele.proposal_status)
              tmp.package_id = ele.package_id
              tmp.package_name = ele.package_name
              tmp.proposal_status = ele.proposal_status
              tmp.is_shared = (ele.is_shared==1)
              tmp.param_json = {...ele.param_json}
              tmp.data_audience = {...ele.param_json.data_audience}
              tmp.data_audience.value_gender = this.changeDataToText(tmp.data_audience.value_gender, this.options.audience_options.gender_options)
              tmp.data_audience.value_age = this.changeDataToText(tmp.data_audience.value_age, this.options.audience_options.age_options)
              tmp.data_audience.value_spend_power = this.changeDataToText(tmp.data_audience.value_spend_power, this.options.audience_options.spend_power_options)
              tmp.data_audience.value_interest = this.changeDataToText(tmp.data_audience.value_interest, this.options.audience_options.interest_options)
              tmp.data_poi =  this.changeDataToText_poi(ele.param_json.data_poi)
              tmp.data_media = this.changeDataToText(ele.param_json.data_media, this.options.media_rank_options.media_format_options)
              tmp.data_rank = this.changeDataToText(ele.param_json.data_rank, this.options.media_rank_options.rank_options)
              tmp.bus_line_qty = ele.param_json.bus_line_qty
              tmp.bus_body_qty = ele.param_json.bus_body_qty
              tmp.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(ele.param_json.poi_ba_label_selection_list)
              tmp.date = ele.param_json.date
              tmp.duration = ele.param_json.duration
              tmp.estimated_cost = Number(ele.param_json.estimated_cost)
              tmp.CPM = ele.param_json.CPM
              tmp.CPM_cluster = ele.param_json.CPM_cluster
              tmp.ifShowViewed = (ele.param_json.ifShowViewed==1)
              tmp.viewed_impression = Number(ele.param_json.viewed_impression)
              tmp.viewed_impression_cluster = Number(ele.param_json.viewed_impression_cluster)
              tmp.bus_line = ele.param_json.bus_line
              
              // check if this proposal is exist or not, if exist: remove it ; if not: add
              var index =  this.selectedMultProposal.findIndex(item => item.id == tmp.id)
              
              if(index >= 0) {
                tmp.checked = true
              } else {
                tmp.checked = false
              }

              this.proposalList.push(tmp)
              
            }
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        })
    },
    updateStatusOption() {
      this.status_options[0].label = this.$t('message.Draft')
      this.status_options[1].label = this.$t('message.Discussion')
      this.status_options[2].label = this.$t('message.Sent')
      this.status_options[3].label = this.$t('message.Win')
      this.status_options[4].label = this.$t('message.Fail')
      this.status_options[5].label = this.$t('message.Cancelled')
    },
    proposalStatusChange(val) {
      //this.updateStatusOption();
      for(let ele in this.status_options){
        if (this.status_options[ele].value == val){
          return this.status_options[ele].label
        }
      }
    },
    stateFormat(row, column, cellValue) {
			cellValue += '';
			if (!cellValue.includes('.')) cellValue += '.';
			return cellValue.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
				return $1 + ',';
			}).replace(/\.$/, '');
		},
    summaryTableRowClassName ({row, rowIndex}){
      if (this.hasNanjing && (row.name == "Nanjing" || row.name == "南京")) {
        return '';
      }
      else if (this.hasWuhan && (row.name == "Wuhan" || row.name == "武汉")) {
        return '';
      }
      else if (this.hasShenzhen && (row.name == "Shenzhen" || row.name == "深圳")) {
        return '';
      }
      else if (this.hasChongqing && (row.name == "Chongqing" || row.name == "重庆")){
        return '';
      }
      else if (this.hasChengdu && (row.name == "Chengdu" || row.name == "成都")){
        return '';
      } else {
        return 'hide-row';
      }
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          if (this.$i18n.locale == 'cn'){
            sums[index] = '合计';
          }
          else if (this.$i18n.locale == 'en'){
            sums[index] = 'Summary';
          }
          return;
        }
        if (index === 1) {
         
          return '--';
        }
          if(index === 2) {
            sums[index] = this.summaryTable[0].bus_line_qty + this.summaryTable[1].bus_line_qty + this.summaryTable[2].bus_line_qty + this.summaryTable[3].bus_line_qty + this.summaryTable[4].bus_line_qty
            
            return
          }
        if (index === 6 ) {
          const values = data.map(item => [Number(item["estimated_cost"]), Number(item["viewed_impression"])]);
          const res = values.reduce((prev, curr) => {
            if (curr!=null && curr.length==2) {
              return [prev[0] + curr[0], prev[1] + curr[1]];
            } else {
              return prev;
            }
          }, [0, 0]);
          sums[index] = res[1]==0 ? 0 : (res[0]/res[1]*1000).toFixed(2);
          return;
        }

        if (index === 7) {
          const values = data.map(item => [Number(item["estimated_cost"]), Number(item["viewed_impression_cluster"])]);
          const res = values.reduce((prev, curr) => {
            if (curr!=null && curr.length==2) {
              return [prev[0] + curr[0], prev[1] + curr[1]];
            } else {
              return prev;
            }
          }, [0, 0]);
          sums[index] = res[1]==0 ? 0 : (res[0]/res[1]*1000).toFixed(2);
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toLocaleString('en-US');
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;

    },

    goBack: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
    },
    goHome: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
    },
    goNext() {
      if (this.enableNext) {
        let obj = {};
        obj.selectedCities = {...this.selectedCities}
        obj.selectedProposals = {...this.selectedProposals}
        obj.selectedProposals.summaryTable = this.summaryTableInfo()
        // obj.selectedProposals.summaryMultiTable = this.summaryTableInfo_test()
        obj.selectedProposals.ifShowViewed = !(obj.selectedProposals.summaryTable[3].impression == obj.selectedProposals.summaryTable[3].impression_cluster)
        obj.selectedMultProposal = this.selectedMultProposal
    
      
        sessionStorage.setItem("Cross_city", JSON.stringify(obj));
        this.$router.push({
            path: "/cross_city_board",
            query: {
              cities : this.selectedCities
            }
        });
      }
    },

    changeCityTab() {
      this.getHistoryData()
      this.radio = this.selectedProposals[this.activeCity]
    },

    handleRadioChange_test(value, row) {
      
     
      let obj = row
      obj.CPM =  (row.estimated_cost/row.viewed_impression*1000).toFixed(2)
      obj.CPM_cluster = (row.estimated_cost/row.viewed_impression_cluster*1000).toFixed(2)

      // check if this proposal is exist or not, if exist: remove it ; if not: add
      var index =  this.selectedMultProposal.findIndex(item => item.id == obj.id)
  
      if(index < 0) {
        if (row.param_json.data_map != ''){
        
          obj.param_json.price = Number(row.param_json.estimated_cost)
        } else {
          obj.param_json.price = Number(row.estimated_cost)
        } 
        obj.param_json.city = row.city
        obj.param_json.clientName = row.clientName
        obj.param_json.id = row.id
        obj.param_json.CPM = obj.CPM
        obj.param_json.CPM_cluster = obj.CPM_cluster
        obj.price = obj.param_json.estimated_cost
        obj.impression = obj.viewed_impression
        obj.impression_cluster = obj.viewed_impression_cluster
        obj.cpm = obj.CPM
        obj.line_qty = row.bus_line_qty
        obj.body_qty = row.bus_body_qty
        obj.cpm_cluster = obj.CPM_cluster
        obj.clientName = row.param_json.clientName
        if(typeof(row.date) =='number'){
          obj.date = new Date(row.date*1000).toISOString().split('T')[0]
        }
        

        obj.param_json.options = {...this.options}
       
        this.selectedMultProposal.push(obj)
      } else {
        this.selectedMultProposal.splice(index, 1)
      }
      this.summaryTable[0].impression =  0        
          this.summaryTable[0].impression_cluster =  0
          this.summaryTable[0].price = 0
          this.summaryTable[0].cpm =  0
          this.summaryTable[0].cpm_cluster = 0
          this.summaryTable[0].bus_line = []
          this.summaryTable[0].bus_line_qty = 0
          this.summaryTable[0].body_qty = 0
          this.summaryTable[0].date = ''
          
          this.summaryTable[1].impression =  0        
          this.summaryTable[1].impression_cluster =  0
          this.summaryTable[1].price = 0
          this.summaryTable[1].cpm =  0
          this.summaryTable[1].cpm_cluster = 0
          this.summaryTable[1].bus_line = []
          this.summaryTable[1].bus_line_qty = 0
          this.summaryTable[1].body_qty = 0
          this.summaryTable[1].date = ''

          this.summaryTable[2].impression =  0        
          this.summaryTable[2].impression_cluster =  0
          this.summaryTable[2].price = 0
          this.summaryTable[2].cpm =  0
          this.summaryTable[2].cpm_cluster = 0
          this.summaryTable[2].bus_line = []
          this.summaryTable[2].bus_line_qty = 0
          this.summaryTable[2].body_qty = 0
          this.summaryTable[2].date = ''

          this.summaryTable[3].impression =  0        
          this.summaryTable[3].impression_cluster =  0
          this.summaryTable[3].price = 0
          this.summaryTable[3].cpm =  0
          this.summaryTable[3].cpm_cluster = 0
          this.summaryTable[3].bus_line = []
          this.summaryTable[3].bus_line_qty = 0
          this.summaryTable[3].body_qty = 0
          this.summaryTable[3].date = ''

          this.summaryTable[4].impression =  0        
          this.summaryTable[4].impression_cluster =  0
          this.summaryTable[4].price = 0
          this.summaryTable[4].cpm =  0
          this.summaryTable[4].cpm_cluster = 0
          this.summaryTable[4].bus_line = []
          this.summaryTable[4].bus_line_qty = 0
          this.summaryTable[4].body_qty = 0
          this.summaryTable[4].date = ''
       
      for(let ele of this.selectedMultProposal) {
        
        if(ele.city == 'Nanjing') {
         
          this.summaryTable[0].impression =  Number(this.summaryTable[0].impression) + Number(ele.param_json.viewed_impression)          
          this.summaryTable[0].impression_cluster =  Number(this.summaryTable[0].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
          this.summaryTable[0].price = Number(this.summaryTable[0].price) + Number(ele.param_json.price)
          this.summaryTable[0].cpm =  (this.summaryTable[0].price/this.summaryTable[0].impression*1000).toFixed(2)
          this.summaryTable[0].cpm_cluster = (this.summaryTable[0].price/this.summaryTable[0].impression_cluster*1000).toFixed(2)
          this.summaryTable[0].bus_line= this.MergeArrayAndFilter(this.summaryTable[0].bus_line,ele.bus_line)
          this.summaryTable[0].bus_line_qty = this.summaryTable[0].bus_line.length
          this.summaryTable[0].line_qty = this.summaryTable[0].bus_line.length
          this.summaryTable[0].body_qty = this.summaryTable[0].body_qty + ele.bus_body_qty
          this.summaryTable[0].date = ele.date
          this.summaryTable[0].duration = ele.duration
        

        } else if (ele.city == 'Wuhan') {
          this.summaryTable[1].impression =  Number(this.summaryTable[1].impression) + Number(ele.param_json.viewed_impression)          
          this.summaryTable[1].impression_cluster =  Number(this.summaryTable[1].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
          this.summaryTable[1].price = Number(this.summaryTable[1].price) + Number(ele.param_json.price)
          this.summaryTable[1].cpm =  (this.summaryTable[1].price/this.summaryTable[1].impression*1000).toFixed(2)
          this.summaryTable[1].cpm_cluster = (this.summaryTable[1].price/this.summaryTable[1].impression_cluster*1000).toFixed(2)
          this.summaryTable[1].bus_line = this.MergeArrayAndFilter(this.summaryTable[1].bus_line,ele.bus_line)
          this.summaryTable[1].bus_line_qty = this.summaryTable[1].bus_line.length
          this.summaryTable[1].line_qty = this.summaryTable[1].bus_line.length
          this.summaryTable[1].body_qty = this.summaryTable[1].body_qty + ele.bus_body_qty
          this.summaryTable[1].date =  ele.date
          this.summaryTable[1].duration = ele.duration

        } else if (ele.city == 'Shenzhen') {
          this.summaryTable[2].impression =  Number(this.summaryTable[2].impression) + Number(ele.param_json.viewed_impression)          
          this.summaryTable[2].impression_cluster =  Number(this.summaryTable[2].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
          this.summaryTable[2].price = Number(this.summaryTable[2].price) + Number(ele.param_json.price)
          this.summaryTable[2].cpm =  (this.summaryTable[2].price/this.summaryTable[2].impression*1000).toFixed(2)
          this.summaryTable[2].cpm_cluster = (this.summaryTable[2].price/this.summaryTable[2].impression_cluster*1000).toFixed(2)
          this.summaryTable[2].bus_line = this.MergeArrayAndFilter(this.summaryTable[2].bus_line,ele.bus_line)
          this.summaryTable[2].bus_line_qty = this.summaryTable[2].bus_line.length
          this.summaryTable[2].line_qty = this.summaryTable[2].bus_line.length
          this.summaryTable[2].body_qty = this.summaryTable[2].body_qty + ele.bus_body_qty
          this.summaryTable[2].date =  ele.date
          this.summaryTable[2].duration = ele.duration


        } else if (ele.city == 'Chongqing'){
          this.summaryTable[3].impression =  Number(this.summaryTable[3].impression) + Number(ele.param_json.viewed_impression)          
          this.summaryTable[3].impression_cluster =  Number(this.summaryTable[3].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
          this.summaryTable[3].price = Number(this.summaryTable[3].price) + Number(ele.param_json.price)
          this.summaryTable[3].cpm =  (this.summaryTable[3].price/this.summaryTable[3].impression*1000).toFixed(2)
          this.summaryTable[3].cpm_cluster = (this.summaryTable[3].price/this.summaryTable[3].impression_cluster*1000).toFixed(2)
          this.summaryTable[3].bus_line = this.MergeArrayAndFilter(this.summaryTable[3].bus_line,ele.bus_line)
          this.summaryTable[3].bus_line_qty = this.summaryTable[3].bus_line.length
          this.summaryTable[3].line_qty = this.summaryTable[3].bus_line.length
          this.summaryTable[3].body_qty = this.summaryTable[3].body_qty + ele.bus_body_qty
          this.summaryTable[3].date =  ele.date
          this.summaryTable[3].duration = ele.duration

        } else if(ele.city == 'Chengdu') {
          this.summaryTable[4].impression =  Number(this.summaryTable[4].impression) + Number(ele.param_json.viewed_impression)          
          this.summaryTable[4].impression_cluster =  Number(this.summaryTable[4].impression_cluster) + Number(ele.param_json.viewed_impression_cluster)
          this.summaryTable[4].price = Number(this.summaryTable[4].price) + Number(ele.param_json.price)
          this.summaryTable[4].cpm =  (this.summaryTable[4].price/this.summaryTable[4].impression*1000).toFixed(2)
          this.summaryTable[4].cpm_cluster = (this.summaryTable[4].price/this.summaryTable[4].impression_cluster*1000).toFixed(2)
          this.summaryTable[4].bus_line = this.MergeArrayAndFilter(this.summaryTable[4].bus_line,ele.bus_line)
          this.summaryTable[4].bus_line_qty = this.summaryTable[4].bus_line.length
          this.summaryTable[4].line_qty = this.summaryTable[4].bus_line.length
          this.summaryTable[4].body_qty = this.summaryTable[4].body_qty + ele.bus_body_qty
          this.summaryTable[4].date =  ele.date
          this.summaryTable[4].duration = ele.duration
        }
      }
      
      this.selectedProposals[this.activeCity] = value
      // summaryTable
      // this.selectedProposals[this.activeCity] = value
      // this.selectedProposals[this.activeCity+"Value"] = row
      // this.selectedProposals[this.activeCity+"Value"].param_json.options = {...this.options}
      // let idx = this.summaryTableIndex[this.activeCity]
      // this.summaryTable[idx].line_qty = row.bus_line_qty
      // this.summaryTable[idx].body_qty = row.bus_body_qty
      // this.summaryTable[idx].impression = Number(this.summaryTable[idx].impression) + Number(row.viewed_impression)
      // this.summaryTable[idx].impression_cluster = Number(this.summaryTable[idx].impression_cluster) + Number(row.ifShowViewed ? row.viewed_impression_cluster : row.viewed_impression)
      // if (row.param_json.data_map != ''){
      //    this.summaryTable[idx].price = Number(row.param_json.data_map.proposal_discount_cost)
      // } else {
      //   this.summaryTable[idx].price = Number(row.estimated_cost)
      // }      
      // this.summaryTable[idx].cpm =  (this.summaryTable[idx].price/row.viewed_impression*1000).toFixed(2)
      // this.summaryTable[idx].cpm_cluster = (this.summaryTable[idx].price/this.summaryTable[idx].impression_cluster*1000).toFixed(2)

      // this.summaryTable[idx].data_audience = row.data_audience
      // this.summaryTable[idx].bus_line = row.bus_line
      // this.summaryTable[idx].date = new Date(row.date*1000).toISOString().split('T')[0]
      // this.summaryTable[idx].duration = row.duration
      // this.summaryTable[idx].data_media = row.data_media
      // this.summaryTable[idx].data_poi_ba_label_selection_list = row.poi_ba_label_selection_list
      // this.summaryTable[idx].data_poi = row.data_poi
      // this.summaryTable[idx].param_json = row.param_json
      //  ele.data_media = this.changeDataToText(ele.param_json.data_media, this.options.media_rank_options.media_format_options)
    },
     MergeArrayAndFilter(array, array1) {
      //将array数组转换成set对象
      let setObj = new Set(array)
      //循环数组array1，并将值通过add插入set对象中,此时重复数据并不会插入其中
      for(let i = 0; i < array1.length; i++) {
        setObj.add(array1[i]);
      }
      let newJson = []
      for(let item1 of setObj){  //循环json数组对象的内容
	      let flag = true;  //建立标记，判断数据是否重复，true为不重复
        for(let item2 of newJson){  //循环新数组的内容
          if(item1.bus_id==item2.bus_id){ //让json数组对象的内容与新数组的内容作比较，相同的话，改变标记为false
            flag = false;
          }
        }
        if(flag){ //判断是否重复
          newJson.push(item1); //不重复的放入新数组。  新数组的内容会继续进行上边的循环。
        }
      }
      //使用Array.from()方法将set对象转换成数组，并使用sort()方法排序
      return Array.from(newJson).sort();
	  },

    handleRadioChange(value, row) {
      this.selectedProposals[this.activeCity] = value
      this.selectedProposals[this.activeCity+"Value"] = row
      this.selectedProposals[this.activeCity+"Value"].param_json.options = {...this.options}
      let idx = this.summaryTableIndex[this.activeCity]
      this.summaryTable[idx].line_qty = row.bus_line_qty
      this.summaryTable[idx].body_qty = row.bus_body_qty
      this.summaryTable[idx].impression = Number(row.viewed_impression)
      this.summaryTable[idx].impression_cluster = Number(row.ifShowViewed ? row.viewed_impression_cluster : row.viewed_impression)
      if (row.param_json.data_map != ''){
         this.summaryTable[idx].price = Number(row.param_json.data_map.proposal_discount_cost)
      } else {
        this.summaryTable[idx].price = Number(row.estimated_cost)
      }      
      this.summaryTable[idx].cpm =  (this.summaryTable[idx].price/row.viewed_impression*1000).toFixed(2)
      this.summaryTable[idx].cpm_cluster = (this.summaryTable[idx].price/this.summaryTable[idx].impression_cluster*1000).toFixed(2)

      this.summaryTable[idx].data_audience = row.data_audience
      this.summaryTable[idx].bus_line = row.bus_line
      this.summaryTable[idx].date = new Date(row.date*1000).toISOString().split('T')[0]
      this.summaryTable[idx].duration = row.duration
      this.summaryTable[idx].data_media = row.data_media
      this.summaryTable[idx].data_poi_ba_label_selection_list = row.poi_ba_label_selection_list
      this.summaryTable[idx].data_poi = row.data_poi
      this.summaryTable[idx].param_json = row.param_json
      //  ele.data_media = this.changeDataToText(ele.param_json.data_media, this.options.media_rank_options.media_format_options)
    },

    changeDataToText_poi(poi) {
      let str = "";
      if (poi.checked_business == true) {
        str = str + this.$t('message.BUSINESS') + ' ';
      }
      if (poi.checked_entertainment == true) {
        str = str + this.$t('message.ENTERTAINEMENT') + ' ';
      }
      if (poi.checked_living == true) {
        str = str + this.$t('message.LIVING') + ' ';
      }
      if (poi.checked_trip == true) {
        str = str + this.$t('message.TRIP');
      }
      return str;
    },

    changeDataToText(data, options) {
      let obj = "";
      if (this.$i18n.locale == 'en'){
        if (typeof(data) == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label;
            }
          }
        } else if (typeof(data) == "object") {
          if (data.length > 1) {
            data = data.sort();
          }
        
          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label) + ' ';
              }
            }
          }
        }
      }else if (this.$i18n.locale == 'cn'){
        if (typeof(data) == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label_cn;
            }
          }
        } else if (typeof(data) == "object") {
          if (data.length > 1) {
            data = data.sort();
          }
        
          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label_cn) + ' ';
              }
            }
          }
        }
      }      
      return obj;
    },

    changeDataToText_PoiSearch(poi_ba_label_selection_list){
      let poi_ba_label_selection_list_text = ''
      for (let index in poi_ba_label_selection_list){
        poi_ba_label_selection_list_text = poi_ba_label_selection_list_text + poi_ba_label_selection_list[index] + ' '
      }
      return poi_ba_label_selection_list_text
    },

    backToCity() {
      this.$router.push({
        path: "/choose_city",
      });
    },

    summaryTableInfo() {
      let obj = {...this.summaryTable}
      obj[0].name = "Nanjing"
      obj[1].name = "Wuhan"
      obj[2].name = "Shenzhen"
      obj[3].name = "Chongqing"
      obj[4].name = "Chengdu"
      const summaryLine = Object.keys(obj).reduce(function (previous, curr) {
          previous.line_qty += obj[curr].bus_line_qty
          previous.body_qty += obj[curr].body_qty
          previous.impression += obj[curr].impression
          previous.impression_cluster += obj[curr].impression_cluster
          previous.price += obj[curr].price
          return previous;
      }, { line_qty: 0, body_qty: 0, impression: 0, impression_cluster: 0, price: 0,});
      summaryLine.cpm = (summaryLine.price/summaryLine.impression*1000).toFixed(2)
      summaryLine.cpm_cluster = (summaryLine.price/summaryLine.impression_cluster*1000).toFixed(2)
      summaryLine.name = "summary"
      obj[5] = summaryLine
      return obj
    },
    

  },
}
</script>

<style lang="scss" scoped>
  /deep/ .el-alert {
    width: 70%;
    margin: auto;
  }

  /deep/ .el-radio__label {
    padding: 0;
  }

  /deep/ .el-radio {
    margin: 0;
  }

  /deep/ .el-table .hide-row {
    display: none;
  }

  .info-list-style {
    background-color: white;
    background-clip: content-box;
    border-radius: 0;
  }

  #KPI1 {
    text-align: center;
  }

  #KPI2 {
    text-align: center;
  }

  /deep/ .el-table__expanded-cell {
    background-color: rgb(239, 239, 239);
  }

  /deep/ .el-table__expanded-cell:hover {
    background-color: rgb(239, 239, 239) !important;
  }

  .p_navi_button_disabled {
    color: rgba(83, 173, 188, 0.5);
    cursor: not-allowed;
    border: 1px solid rgba(37, 74, 110, 0.5);
    background: #f7f7f7;
    font-size: 25px;
  }
  
  /deep/ .el-alert__title {
    font-size: 18px;
  }

  /deep/ .el-alert__icon {
    font-size: 18px;
  }
</style>